'use client';

import React, { useState } from 'react';
import styles from './login.module.scss';
import Cookies from 'js-cookie';
import { Button, Container, Input, Notification, Title } from '@mantine/core';

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault(); // Prevent default form submission
    setError('');

    try {
      const response = await fetch('/api/authenticate', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });

      if (!response.ok) {
        throw new Error('Identifiants invalides');
      }

      const data = await response.json();

      if (data?.token) {
        Cookies.set('authToken', data.token); // store the raw JWT
        location.replace('/jarvis');
      } else {
        throw new Error('Échec de l’authentification');
      }
    } catch (error) {
      //@ts-ignore
      setError(error.message || 'Erreur inattendue');
    }
  };

  return (
    <div className={styles.pageWrapper}>
      <Container size="xs" className={styles.loginContainer}>
        <Title order={2} className={styles.title}>
          Connexion
        </Title>

        {error && (
          <Notification color="red" title="Erreur" onClose={() => setError('')} mt="md">
            {error}
          </Notification>
        )}

        <form onSubmit={handleLogin}>
          <Input
            name="username"
            placeholder="Nom d'utilisateur"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className={styles.input}
          />

          <Input
            name="password"
            placeholder="Mot de passe"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className={styles.input}
            mt="md"
          />

          <Button type="submit" className={styles.button} mt="md">
            Connexion
          </Button>
        </form>
      </Container>
    </div>
  );
};

export default LoginPage;
